import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { CustomerAccountDialogComponent } from './customer-account-dialog.component';

@Injectable()
export class CustomerAccountDialogService {
  constructor(private dialog: MatDialog) {}

  public open(
    userId?: number,
    vesselId?: number,
    fromGoogleAuth?: boolean,
    completingProfile?: boolean,
  ): Observable<boolean> {
    let dialogRef: MatDialogRef<CustomerAccountDialogComponent>;
    const mobile = window && window.screen && window.screen.width < 960;
    const config: any = {
      data: {
        userIdAfterAuth: userId,
        vesselId: vesselId,
        fromGoogleAuth: fromGoogleAuth,
        completingProfile: completingProfile,
      },
    };
    if (mobile) {
      console.log('mobile dialog');
      config.maxWidth = '100vw';
      config.height = mobile ? '100vh' : '80vh';
      config.width = '100%';
      config.maxHeight = '100vh !important';
    }

    dialogRef = this.dialog.open(CustomerAccountDialogComponent, config);
    return dialogRef.afterClosed();
  }
}
